import _defineProperty from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var _authConfigurationErr;

import { createAssertionFunction } from '../../../errors/createAssertionFunction.mjs';
import '../../../types/errors.mjs';
import '../../../errors/errorHelpers.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var AuthConfigurationErrorCode;

(function (AuthConfigurationErrorCode) {
  AuthConfigurationErrorCode["AuthTokenConfigException"] = "AuthTokenConfigException";
  AuthConfigurationErrorCode["AuthUserPoolAndIdentityPoolException"] = "AuthUserPoolAndIdentityPoolException";
  AuthConfigurationErrorCode["AuthUserPoolException"] = "AuthUserPoolException";
  AuthConfigurationErrorCode["InvalidIdentityPoolIdException"] = "InvalidIdentityPoolIdException";
  AuthConfigurationErrorCode["OAuthNotConfigureException"] = "OAuthNotConfigureException";
})(AuthConfigurationErrorCode || (AuthConfigurationErrorCode = {}));

var authConfigurationErrorMap = (_authConfigurationErr = {}, _defineProperty(_authConfigurationErr, AuthConfigurationErrorCode.AuthTokenConfigException, {
  message: 'Auth Token Provider not configured.',
  recoverySuggestion: 'Make sure to call Amplify.configure in your app.'
}), _defineProperty(_authConfigurationErr, AuthConfigurationErrorCode.AuthUserPoolAndIdentityPoolException, {
  message: 'Auth UserPool or IdentityPool not configured.',
  recoverySuggestion: 'Make sure to call Amplify.configure in your app with UserPoolId and IdentityPoolId.'
}), _defineProperty(_authConfigurationErr, AuthConfigurationErrorCode.AuthUserPoolException, {
  message: 'Auth UserPool not configured.',
  recoverySuggestion: 'Make sure to call Amplify.configure in your app with userPoolId and userPoolClientId.'
}), _defineProperty(_authConfigurationErr, AuthConfigurationErrorCode.InvalidIdentityPoolIdException, {
  message: 'Invalid identity pool id provided.',
  recoverySuggestion: 'Make sure a valid identityPoolId is given in the config.'
}), _defineProperty(_authConfigurationErr, AuthConfigurationErrorCode.OAuthNotConfigureException, {
  message: 'oauth param not configured.',
  recoverySuggestion: 'Make sure to call Amplify.configure with oauth parameter in your app.'
}), _authConfigurationErr);
var assert = createAssertionFunction(authConfigurationErrorMap);
export { AuthConfigurationErrorCode, assert };